package com.mps.asc_app.util

/**
 * Wenn sich der Text/Umfang ändert: Version erhöhen. Dann müssen Bestandsnutzer erneut zustimmen.
 */
const val PRIVACY_CONSENT_VERSION: String = "2026-04-18"

val PRIVACY_CONSENT_TEXT: String = """
Datenschutzerklärung – Anzeige von Vor- und Nachnamen im Buchungstool

Im Rahmen der Nutzung dieses Buchungstools werden Ihr Vor- und Nachname verarbeitet und innerhalb des Systems angezeigt. Diese Anzeige erfolgt für alle registrierten und freigeschalteten Mitglieder des Vereins.

Zweck der Datenverarbeitung
Die Darstellung von Vor- und Nachnamen dient der Transparenz bei Buchungen sowie der besseren Organisation und Abstimmung zwischen den Mitgliedern (z. B. bei der Nutzung von Spielfeldern oder Zeitfenstern).

Sichtbarkeit der Daten
Ihr Vor- und Nachname ist für alle anderen Mitglieder sichtbar, die Zugriff auf das Buchungstool haben. Eine öffentliche Einsicht außerhalb des geschlossenen Nutzerkreises erfolgt nicht.

Rechtsgrundlage
Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.

Freiwilligkeit und Widerruf
Die Angabe und Anzeige Ihres Vor- und Nachnamens erfolgt freiwillig. Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen. In diesem Fall ist eine weitere Nutzung des Buchungstools ggf. nur eingeschränkt möglich.

Speicherdauer
Ihre personenbezogenen Daten werden nur so lange gespeichert, wie dies für die Nutzung des Buchungstools erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen.

Betroffenenrechte
Sie haben jederzeit das Recht auf Auskunft über die zu Ihrer Person gespeicherten Daten, deren Berichtigung, Löschung oder Einschränkung der Verarbeitung sowie ein Recht auf Datenübertragbarkeit.

Bei Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte wenden Sie sich bitte an den verantwortlichen Ansprechpartner des Vereins.
""".trim()

